module.exports = __webpack_public_path__ + "static/img/AW.ea8a7810.png";